import { combineReducers } from 'redux';
import retailReducer from './retailReducer';

export default combineReducers({
    retail_reducer: retailReducer
});